import { SaleAdvert, RentalAdvert } from "../types/types";


export const StaticMapImage = (advert: RentalAdvert | SaleAdvert, apiKey: string) : string => {
  if (!advert.longitude || !advert.latitude) {
    return;
  }
  const marker = `markers=icon:${encodeURIComponent("https://gites.s3.eu-central-1.amazonaws.com/marker.png")}|${advert.latitude},${advert.longitude}`
  return `https://maps.googleapis.com/maps/api/staticmap?size=548x200&zoom=8&${marker}&key=${apiKey}`
}
